import { CURRENT_MANAGER_CREATE, CURRENT_MANAGER_UPDATE, CURRENT_MANAGER_VALIDATE, INFORM_PREMIUM_FOLLOWES } from '../constants/currentManagerTypes';

export function currentManagerCreate(params) {
  return {
    type: CURRENT_MANAGER_CREATE,
    payload: params
  };
}

export function currentManagerUpdate(params) {
  return {
    type: CURRENT_MANAGER_UPDATE,
    payload: params
  };
}

export function currentManagerValidate(params) {
  return {
    type: CURRENT_MANAGER_VALIDATE,
    payload: params
  };
}

export function informPremiumFollowers(params) {
  return { type: INFORM_PREMIUM_FOLLOWES, payload: params };
}



// WEBPACK FOOTER //
// ./app/actions/currentManagerActions.js